(() => {
  const url = document.currentScript.dataset.productScript;
  let promise;
  const load = () => {
    if (customElements.get('variant-selects')) return Promise.resolve();
    if (promise) return promise;
    promise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = url;
      script.async = true;
      script.onload = resolve;
      script.onerror = () => { script.remove(); promise = null; reject(new Error('Product controls unavailable')); };
      document.head.appendChild(script);
    });
    return promise;
  };
  window.DontixProductScripts = { load };
  const controls = 'variant-selects, product-form, product-slider, product-add-to-cart-sticky';
  const observer = new MutationObserver(() => {
    if (document.querySelector(controls)) {
      observer.disconnect();
      load().catch(() => {});
    }
  });
  if (document.querySelector(controls)) load().catch(() => {});
  else observer.observe(document.body, { childList: true, subtree: true });
})();
